import Vue from 'vue'
import * as Sentry from "@sentry/vue";

if (typeof window !== 'undefined') {
  window.Sentry = Sentry
}

const IGNORED_ERROR_NAMES = ['AbortError', 'CanceledError']
const IGNORED_ERROR_CODES = ['ECONNABORTED', 'ERR_CANCELED']
const IGNORED_MESSAGE_SNIPPETS = [
  'Network Error',
  'Failed to fetch',
  'Request aborted',
  'The user aborted a request',
  'Load failed'
]

function includesIgnoredMessage(value) {
  if (!value) {
    return false
  }

  return IGNORED_MESSAGE_SNIPPETS.some((snippet) => value.includes(snippet))
}

function shouldIgnoreError(error) {
  if (!error) {
    return false
  }

  const name = error.name
  const code = error.code
  const message = typeof error.message === 'string' ? error.message : ''

  return (
    (name && IGNORED_ERROR_NAMES.includes(name)) ||
    (code && IGNORED_ERROR_CODES.includes(code)) ||
    includesIgnoredMessage(message)
  )
}

function shouldIgnoreEvent(event, hint) {
  if (hint?.originalException && shouldIgnoreError(hint.originalException)) {
    return true
  }

  const message = event?.message || ''
  if (includesIgnoredMessage(message)) {
    return true
  }

  const exception = event?.exception?.values?.[0]
  if (!exception) {
    return false
  }

  const exceptionType = exception.type || ''
  const exceptionValue = exception.value || ''

  if (IGNORED_ERROR_NAMES.includes(exceptionType)) {
    return true
  }

  if (includesIgnoredMessage(exceptionValue)) {
    return true
  }

  return false
}

if (window.env !== 'development') {
  Sentry.init({
    Vue,
    dsn: "https://1c3b48b84622842a9fd69c953d6cecc1@o24217.ingest.sentry.io/4506833611718656",
    release: window.release,
    environment: window.env,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0,
    tracePropagationTargets: ["localhost", /karrotmarket\.com/],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    ignoreErrors: [],
    beforeSend(event, hint) {
      if (shouldIgnoreEvent(event, hint)) {
        return null
      }

      return event
    },
    initialScope: {
      tags: { country: window.countryCode },
      user: window.sentryUser
    },
  });
}
